module.exports = __webpack_public_path__ + "static/media/mountadex-combined.ff1cc384.png";